export function getTranslation<T extends {language?: string}>(
  translations: T[] | undefined,
  language: string,
): T | undefined {
  return translations?.find((t) => t?.language === language);
}
